import { createApp } from 'vue';
import AppVue from './presentation/app.vue';
import { GlobalsPlugin } from './vue-globals';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { EditorIntegration } from './infrastructure/editor-platform/editor-integration';
import { mediatedEventPublish } from './platform/core/mediated-events';
import { PlatformIntegration } from './platform/platform-integration';
import {
	IEventPayloadRenderEditor,
	IEventPayloadRender,
	IEventPayloadRenderOverview,
	IEditorIntegration,
	EditorEvent,
	ScholarshipEditorEvent,
} from '@studyportals/scholarships-editor-integration';

import './tinymce';

declare global {
	interface Window {
		tinymce: unknown;
	}
}

const mount = (page: string, containerId: string): void => {
	const appProps = {
		page,
	};

	createApp(AppVue, appProps).use(GlobalsPlugin).use(ElementPlus, { zIndex: 10 }).mount(containerId);
};

const preparePlatformIntegration = (payload: IEventPayloadRender): void => {
	PlatformIntegration.instance.context = payload.context;
	PlatformIntegration.instance.authorizer = payload.authorizer;
	PlatformIntegration.instance.router = payload.router;
	PlatformIntegration.instance.ui = payload.ui;
};

document.addEventListener(ScholarshipEditorEvent.RENDER_EDITOR, (evt: unknown) => {
	const event = evt as CustomEvent<IEventPayloadRenderEditor>;

	preparePlatformIntegration(event.detail);
	mount('ScholarshipEditor', event.detail.rootContainerId);
});

document.addEventListener(ScholarshipEditorEvent.RENDER_OVERVIEW, (evt: unknown) => {
	const event = evt as CustomEvent<IEventPayloadRenderOverview>;

	preparePlatformIntegration(event.detail);
	mount('ScholarshipOverview', event.detail.rootContainerId);
});

mediatedEventPublish<IEditorIntegration>(EditorEvent.LOADED, EditorIntegration.instance);
